/**
 * Browser utilities for safe localStorage and window operations
 */

/**
 * Check if code is running in browser environment
 */
export const isBrowser = typeof window !== "undefined";

/**
 * Safe localStorage operations
 */
export const storage = {
  get: (key) => {
    if (!isBrowser) return null;
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      console.error("localStorage get error:", error);
      return null;
    }
  },

  set: (key, value) => {
    if (!isBrowser) return false;
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.error("localStorage set error:", error);
      return false;
    }
  },

  remove: (key) => {
    if (!isBrowser) return false;
    try {
      window.localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error("localStorage remove error:", error);
      return false;
    }
  },

  clear: () => {
    if (!isBrowser) return false;
    try {
      window.localStorage.clear();
      return true;
    } catch (error) {
      console.error("localStorage clear error:", error);
      return false;
    }
  },
};

/**
 * Safe window operations
 */
export const browser = {
  redirect: (url) => {
    if (!isBrowser) return;
    try {
      window.location.href = url;
    } catch (error) {
      console.error("Redirect error:", error);
    }
  },

  reload: () => {
    if (!isBrowser) return;
    try {
      window.location.reload();
    } catch (error) {
      console.error("Reload error:", error);
    }
  },

  open: (url, target = "_blank") => {
    if (!isBrowser) return;
    try {
      window.open(url, target);
    } catch (error) {
      console.error("Open window error:", error);
    }
  },
};
